import { render, staticRenderFns } from "./ModalReferralOrderDetails.vue?vue&type=template&id=65ebab57&"
import script from "./ModalReferralOrderDetails.vue?vue&type=script&lang=js&"
export * from "./ModalReferralOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports